export default __webpack_public_path__ + "static/media/secondcat2.e8778997.gif";